document.addEventListener("DOMContentLoaded", function () {
  let timerInterval;
  const DURATION = 599; // 9:59
  let cartNotEmpty = false; // Track cart state on load

  function startTimer(timerDisplay) {
    clearInterval(timerInterval);
    let totalSeconds = parseInt(sessionStorage.getItem("cartTimer")) || DURATION;

    const updateTimer = () => {
      if (totalSeconds <= 0) {
        clearInterval(timerInterval);
        sessionStorage.removeItem("cartTimer");
        return;
      }

      const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, "0");
      const seconds = (totalSeconds % 60).toString().padStart(2, "0");

      timerDisplay.textContent = `${minutes}:${seconds}`;
      sessionStorage.setItem("cartTimer", totalSeconds);
      totalSeconds--;
    };

    updateTimer();
    timerInterval = setInterval(updateTimer, 1000);
  }

  function showAndStartTimer() {
    const timerWrapper = document.querySelector(".cart-timer__wrapper");
    const timerDisplay = document.getElementById("cart-timer");
    if (!timerWrapper || !timerDisplay) return;

    timerWrapper.classList.remove("hidden");
    startTimer(timerDisplay);
  }

  function hideAndStopTimer() {
    const timerWrapper = document.querySelector(".cart-timer__wrapper");
    if (!timerWrapper) return;

    timerWrapper.classList.add("hidden");
    clearInterval(timerInterval);
    sessionStorage.removeItem("cartTimer");
  }

  // 🧠 Check if cart is empty using AJAX
  async function checkCartAndToggleTimer() {
    try {
      const res = await fetch("/cart.js");
      const data = await res.json();
      cartNotEmpty = data.item_count > 0;

      if (cartNotEmpty) {
        const timerWrapper = document.querySelector(".cart-timer__wrapper");
        if (!timerWrapper || !timerWrapper.classList.contains("hidden")) return;
        showAndStartTimer();
      } else {
        hideAndStopTimer();
      }
    } catch (e) {
      console.error("Error checking cart:", e);
    }
  }

  // 🧩 1. Catch all Add to Cart button clicks (desktop + mobile)
  document.querySelectorAll('[data-add-to-cart], .product__submit__add').forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(checkCartAndToggleTimer, 800);
    });
  });

  // 🧩 2. Intercept AJAX Add/Remove/Update Cart calls (mobile + desktop)
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (
      args[0].includes("/cart/add") ||
      args[0].includes("/cart/change") ||
      args[0].includes("/cart/update")
    ) {
      setTimeout(checkCartAndToggleTimer, 500);
    }
    return response;
  };

  // 🧩 3. Resume or start timer when cart drawer opens (if cart not empty)
  document.addEventListener("theme:cart:open", () => {
    const timerWrapper = document.querySelector(".cart-timer__wrapper");
    const timerDisplay = document.getElementById("cart-timer");

    if (cartNotEmpty && timerWrapper && timerDisplay) {
      timerWrapper.classList.remove("hidden");
      startTimer(timerDisplay);
    }
  });

  // 🧩 4. Run once on page load (to detect existing cart)
  checkCartAndToggleTimer();
});
